'use strict';var _desc,_value,_class;function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key]});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=!0}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=void 0}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null}return desc}

const _=require('pulsar-utils/dist-es6/_');
const treeUtils=require('pulsar-utils/dist-es6/treeUtils');
const EntityDictionary=require('pulsar-utils/dist-es6/domain/entityDictionary');
const BaseController=require('../../../../dist-es6/client/angularCommon/baseController');
const HandleUncaughtErrors=require('../../../../dist-es6/client/services/uncaughtErrorHandler').Annotations.HandleUncaughtErrors;
const SocketResponse=require('../../../../dist-es6/client/dtos/socketResponse');let

PersonModel=class PersonModel{
constructor(id,firstName,lastName,employeeId){
this._id=id;
this._isSelected=!1;
this._firstName=firstName;
this._lastName=lastName;
this._employeeId=employeeId;
}
get id(){
return this._id;
}
get firstName(){
return this._firstName;
}
get lastName(){
return this._lastName;
}
get employeeId(){
return this._employeeId;
}
get displayName(){
return`${this.lastName}, ${this.firstName}`;
}

get isSelected(){
return this._isSelected;
}

set isSelected(isSelected){
this._isSelected=isSelected;
}};


const BaseColumnDefinitions=[{
label:'Name',
isInitiallyActive:!0,
defaultAscending:!0,
orderBy:['displayName'],
columnClass:'name-column'},
{
label:'Employee Code',
defaultAscending:!0,
orderBy:['employeeId'],
columnClass:'employee-code-column'}];


const GroupColumnDefinitions=[{
columnClass:'select-column'}].

concat(BaseColumnDefinitions);let

GroupsController=(_class=class GroupsController extends BaseController{
constructor(
$scope,
$state,
$timeout,
$modal,
groupBasedDataHelperService,
personService,
groupsCommandAndQueryService,
groupsPopulationService,
organizationDefaultsService,
breadcrumbsService,
socketService,
groupUpdateErrorHandlingService,
userService,
groupTreeService,
uncaughtErrorHandler){

super(uncaughtErrorHandler);
this._$state=$state;
this._$scope=$scope;
this._$modal=$modal;
this._$timeout=$timeout;
this._personService=personService;
this._groupsCommandAndQueryService=groupsCommandAndQueryService;
this._groupsPopulationService=groupsPopulationService;
this._organizationDefaultsService=organizationDefaultsService;
this._socketService=socketService;
this._groupUpdateErrorHandlingService=groupUpdateErrorHandlingService;
this._groupTreeService=groupTreeService;

this._$scope.$watch('controller.selectedGroup',(newlySelectedGroup,oldSelectedGroup)=>{
if(_.exists(newlySelectedGroup)){
this._$state.go('fdc.features.groups',{
groupId:newlySelectedGroup.id});

}
});


groupBasedDataHelperService.clearCaches();

breadcrumbsService.startTrail('Groups');

this._reload=this._reload.bind(this);
this._reload(this._$state.params.groupId);
}

_createEveryoneGroupModel(persons,organizationThresholds){
return{
name:'Organization',
isSpecialGroupContainingWholeOrg:!0,
id:null,
persons:persons,
fatigueThreshold:organizationThresholds.fatigueThreshold,
deviationThreshold:organizationThresholds.deviationThreshold,
children:[]};

}


async _reload(groupIdToSelect){
let[rawPersons,rawGroupTree,organizationThresholds]=await Promise.all([
this._personService.getAllPersons(),
this._groupsCommandAndQueryService.getGroupTree(),
this._organizationDefaultsService.getOrganizationThresholds()]);


this._allPersons=rawPersons.map(p=>new PersonModel(p.id,p.firstName,p.lastName,p.employeeId));
this._defaultFatigueThreshold=organizationThresholds.fatigueThreshold;
this._defaultDeviationThreshold=organizationThresholds.deviationThreshold;
let everyoneGroup=this._createEveryoneGroupModel(this._allPersons,organizationThresholds);

let currentSelections={};
if(_.exists(this._groupTree)){
for(let group of treeUtils.flatten(this._groupTree)){
for(let person of group.persons){
currentSelections[`${group.id}${person.id}`]=person.isSelected;
}
}
}

let populatedGroups=this._groupsPopulationService.populate(rawGroupTree,EntityDictionary.create(this._allPersons));

for(let group of treeUtils.flatten(populatedGroups)){
group.isSpecialGroupContainingWholeOrg=!1;
for(let person of group.persons){
person.isSelected=currentSelections[`${group.id}${person.id}`]||!1;
}
}

await new Promise(resolve=>{
this._$timeout(()=>{
this._groupTree=[everyoneGroup].concat(populatedGroups);
this._groupTreeService.groupTree=this._groupTree;
if(_.exists(groupIdToSelect)){
this._groupTreeService.selectGroupWithId(groupIdToSelect,{forceExpansion:!0});
}
resolve();
});
});
}

set selectedGroup(newlySelectedGroup){
this._groupTreeService.selectGroupWithId(newlySelectedGroup.id);
}

get selectedGroup(){
return this._groupTreeService.selectedGroup;
}

get groupTree(){
return this._groupTree;
}

get anyPersonsSelected(){
return _.some(this.filteredPersons,p=>p.isSelected);
}

onRowClick(item,$event){
if(_.get($event,'target.tagName')==='INPUT'){


$event.stopPropagation();
return;
}
this._$timeout(()=>item.isSelected=!item.isSelected);
}

editGroup(){
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/groups/modals/editGroupModalView',
controller:'EditGroupModalController as controller',
resolve:{
resolvedParameters:()=>{
return{
group:this.selectedGroup,
onGroupSaved:this._reload,
onGroupDeleted:this._reload};

}}});


}

createNewGroup(){
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/groups/modals/createGroupModalView',
controller:'CreateGroupModalController as controller',
resolve:{
groupTree:()=>this.groupTree.filter(group=>!group.isSpecialGroupContainingWholeOrg),
onGroupCreated:()=>this._reload}});


}


async removeSelectedPeopleFromGroup(){
let peopleToRemove=this.selectedGroup.persons.filter(p=>p.isSelected&&_.includes(this.filteredPersons,p));

const response=await this._socketService.sendAndWaitForResponse('RemovePersonsFromGroup',{
groupId:this.selectedGroup.id,
personIds:peopleToRemove.map(p=>p.id)});


if(!SocketResponse.succeeded(response)){
this._groupUpdateErrorHandlingService.handle(response);
}

await this._reload(this.selectedGroup.id);
}

addPersonsToGroup(){
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/groups/modals/addPersonsToGroupModalView',
controller:'AddPersonsToGroupModalController as controller',
resolve:{
group:()=>this.selectedGroup,
organizationPersons:()=>this._allPersons,
onPersonsAdded:()=>this._reload}});


}

setThreshold(){
let modalInstance=this._$modal.open({
templateUrl:'/templates/features/groups/modals/setThresholdModalView',
controller:'SetThresholdModalController as controller',
resolve:{
resolvedParameters:()=>{
return{
defaultFatigueThreshold:this._defaultFatigueThreshold,
defaultDeviationThreshold:this._defaultDeviationThreshold,
group:this.selectedGroup,
onThresholdSet:this._reload};

}}});


}

get groupColumnDefinitions(){
return GroupColumnDefinitions;
}

get organizationColumnDefinitions(){
return BaseColumnDefinitions;
}

get defaultFatigueThreshold(){
return _.get(this.groupTree,'0.fatigueThreshold');
}

get defaultDeviationThreshold(){
return _.get(this.groupTree,'0.deviationThreshold');
}},(_applyDecoratedDescriptor(_class.prototype,'_reload',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'_reload'),_class.prototype),_applyDecoratedDescriptor(_class.prototype,'removeSelectedPeopleFromGroup',[HandleUncaughtErrors],Object.getOwnPropertyDescriptor(_class.prototype,'removeSelectedPeopleFromGroup'),_class.prototype)),_class);


module.exports=GroupsController;
//# sourceMappingURL=groupsController.js.map
